import ServiceGraphQL from 'src/service/gql-service';
import { removeCustomer } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const RemoveCustomer = (id) => {
  const params = {
    query: removeCustomer.QUERY,
    variables: {
      filter: {
        _id: id
      }
    }
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
